import { useUser } from "@packsize/authentication";

export const useCanManageJobs = () => {
	const { hasAnyRole } = useUser();

	return hasAnyRole(["managepackagingsolutions", "managejobactions"]) === true;
};
